import type {FC} from 'react';
import type {GroupHeadingProps} from 'react-select';

import styled from 'styled-components';

import {ms} from '../../../../styles';
import {Text} from '../../../Text';

const StyledText = styled(Text).attrs({
  weight: 'bold',
})`
  margin-inline-start: ${ms(12)};
  margin-block-end: ${ms(8)};
  display: block;
`;

export const SelectGroupHeadingV2: FC<SelectGroupHeadingV2.Props> = props => {
  return <StyledText>{props.children}</StyledText>;
};

export namespace SelectGroupHeadingV2 {
  export type Props = GroupHeadingProps;
}
